import Player from '@vimeo/player';
import YTPlayer from 'yt-player';

export class VideoModal {
    /*
    * Init the class
    *
    * @param    {HTMLElement} rootEl       The root element of the block
    */
    constructor(rootEl) {
        // Store elements
        this.rootEl = rootEl;
        this.buttonEl = rootEl.querySelector('.video-modal-button');
        this.blockId = rootEl.id;

        this.controlClass = 'modal-open';
        this.blockControlClass = 'video-modal-open';
        this.modalClose = rootEl.querySelector('#'+this.blockId+'-modal-close');  
        this.modalVideo = rootEl.querySelector('#'+this.blockId+'-modal-video');  
        this.modalIframe = rootEl.querySelector('#'+this.blockId+'-modal-iframe');
        this.modalYoutube = rootEl.querySelector('#'+this.blockId+'-modal-youtube');

        // Handle user clicking on modal button
        this.buttonEl.addEventListener('click', this.modalToggle.bind(this));

        // Handle user clicking close modal button
        this.modalClose.addEventListener('click', this.modalToggle.bind(this));

        // Handle user changing select input
        const overlayEl = this.rootEl.querySelector(
            `.fullscreen-video__modal-overlay`
        );


        if (overlayEl instanceof window.HTMLElement) {
            overlayEl.addEventListener('click', this.modalToggle.bind(this));
        }

        // Load Vimeo player
        if (this.modalIframe) {
            this.player = new Player(this.modalIframe);
        }

        // Load Youtube player
        if (this.modalYoutube) {
            this.player = new YTPlayer('#'+this.blockId+'-modal-youtube')
            this.player.load(this.modalYoutube.dataset.embed);
        }
    }

    /*
    * User has clicked the modal button
    *
    * @return    {void}
    */
    modalToggle() {
        const alreadyOpen = this.rootEl.classList.contains(this.blockControlClass);
        // Add the body class
        if (!alreadyOpen) {
            document.body.classList.add(this.controlClass);
            this.rootEl.classList.add(this.blockControlClass);

            // Play video
            if (this.modalVideo) {
                this.modalVideo.play();
            }

            // If Vimeo or YouTube play video
            if (this.modalIframe || this.modalYoutube) {
                this.player.play();
            }

        } else {
            document.body.classList.remove(this.controlClass);
            this.rootEl.classList.remove(this.blockControlClass);

            // Pause video
            if (this.modalVideo) {
                this.modalVideo.pause();
            }

            // If Vimeo or YouTube pause video
            if (this.modalIframe || this.modalYoutube) {
                this.player.pause();
            }

        }
    }
}

